// src/components/charts/ContentFormatBar.jsx
//
// Population-true bar of /runs/stats?group_by=content_format.
import React from 'react';
import { CHART_SERIES, COLORS, FONT_SANS } from '../../constants/theme.js';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Sort `groupBy=content_format` buckets by count desc. Null/empty key → "Senza formato".
 * Exported for unit testing.
 */
export function contentFormatRows(stats) {
  if (!stats?.buckets) return [];
  return [...stats.buckets]
    .map(b => ({
      format: b.key == null || b.key === '' ? 'Senza formato' : b.key,
      count: b.count || 0,
    }))
    .sort((a, b) => b.count - a.count);
}

export default function ContentFormatBar({ data }) {
  const rows = contentFormatRows(data);
  if (rows.length === 0) return null;
  return (
    <ResponsiveContainer width="100%" height={Math.max(180, rows.length * 32 + 40)}>
      <BarChart data={rows} layout="vertical" margin={{ top: 8, right: 24, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" horizontal={false} />
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: COLORS.textSecondary }} />
        <YAxis type="category" dataKey="format" width={120} tick={{ fontSize: 11, fill: COLORS.ink }} />
        <Tooltip contentStyle={{ fontSize: 12, fontFamily: FONT_SANS }} />
        <Bar dataKey="count" fill={CHART_SERIES[0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
